module.exports = __webpack_public_path__ + "img/shrimp-frozen.ccd35a5f.png";